import { LoadingIndicator } from '../../components/onboarding/LoadingIndicator';
import { useAuth } from '../../contexts/AuthContext';
import AccessDenied from '../../pages/onboarding/AccessDenied';
import type { RoutePermissionConfig } from './routePermissions';

interface RequirePermissionProps {
  config: RoutePermissionConfig;
  children: JSX.Element;
}

/**
 * Router-level role guard. Waits for AuthContext, then renders children or
 * AccessDenied. API authorization remains the source of truth for security.
 */
function RequirePermission({ config, children }: RequirePermissionProps) {
  const { currentUser, isLoading } = useAuth();

  if (isLoading && !currentUser) {
    return (
      <main className="flex flex-1 flex-col bg-surface-muted">
        <LoadingIndicator layout="page" />
      </main>
    );
  }

  if (!currentUser || !config.allow(currentUser)) {
    return (
      <AccessDenied
        title={config.title}
        message={config.message}
        currentRole={currentUser?.platformRole}
        roleHintByRole={config.roleHintByRole}
      />
    );
  }

  return children;
}

export default RequirePermission;
